import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  // Property & Loan
  {
    name: 'isFirstTimeHomeBuyer',
    label: 'Is First Time Home Buyer',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'intendToOccupyPropertyAsPrimaryResidence',
    label: 'Will you occupy the property as your primary residence?',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'ownershipInterestPastThreeYears',
    label: 'Have you had an ownership interest in another property in the last three years?',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'pastThreeYearsPropertyPurpose',
    label: 'What type of property did you own? - Property Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'titleHoldingType',
    label: 'How did you hold title to the property? - Title of the property',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'relationshipWithPropertySeller',
    label:
      'Do you have a family relationship or business affiliation with the seller of the property?',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'partOfDownPaymentBorrowed',
    label:
      'Are you borrowing any money for this real estate transaction (e.g., money for your closing costs or down payment) or\n' +
      'obtaining any money from another party, such as the seller or realtor, that you have not disclosed on this loan application?',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'partOfDownPaymentBorrowedAmount',
    label: 'What is the amount of this money?',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'loanOnAnotherProperty',
    label:
      'Have you or will you be applying for a mortgage loan on another property (not the property securing this loan) on or before closing this transaction that is not disclosed on this loan application? ',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'anyNewCreditOutsideOfTheLoan',
    label:
      'Have you or will you be applying for any new credit (e.g., installment loan, credit card, etc.) on or before closing this loan that\n' +
      'is not disclosed on this application?',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isPropertyLien',
    label:
      'Will this property be subject to a lien that could take priority over the first mortgage lien, such as a clean energy lien paid\n' +
      'through your property taxes (e.g., the Property Assessed Clean Energy Program)?',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  // Finances
  {
    name: 'guarantorOnAnyDebtOutsideTheLoan',
    label:
      'Are you a co-signer or guarantor on any debt or loan that is not disclosed on this application?',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'outstandingJudgements',
    label: 'Are there any outstanding judgments against you?',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'presentlyObligatedOnAnyLoanOrDebt',
    label: 'Are you currently delinquent or in default on a Federal debt?',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'partyToLawSuite',
    label:
      'Are you a party to a lawsuit in which you potentially have any personal financial liability?',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'propertyInLieuOfForeclosureInPastSevenYears',
    label: 'Have you conveyed title to any property in lieu of foreclosure in the past 7 years?',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'foreclosureSoldLessOutstandingBalanceWithinPastSevenYears',
    label:
      'Within the past 7 years, have you completed a pre-foreclosure sale or short sale, whereby the property was sold to a\n' +
      'third party and the Lender agreed to accept less than the outstanding mortgage balance due?',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isLastMonthsForeclosure',
    label: 'Have you had property foreclosed upon in the last 7 years?',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isLastMonthsBankruptcy',
    label: 'Have you declared bankruptcy within the past 7 years?',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'bankruptTypes',
    label: 'Identify the type(s) of bankruptcy',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'bankruptcyFilingDate',
    label: 'Bankruptcy filing date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'bankruptcyDischargeDate',
    label: 'Bankruptcy discharge date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'bankruptcyDismissalDate',
    label: 'Bankruptcy dismissal date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'foreclosureCompletionDate',
    label: 'Foreclosure completion date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'shortSaleDate',
    label: 'Short sale date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'deedInLieuDate',
    label: 'Deed-in-lieu date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'creditEventDatesOverridden',
    label: 'Use only the dates entered here',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  // Military Services
  {
    name: 'isServedInMilitary',
    label:
      'Did you (or your deceased spouse) ever serve, or are you currently serving, in the United States Armed Forces?',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isCurrentlyServing',
    label: 'Currently serving on active duty with projected expiration date of service/tour',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'currentlyServingDate',
    label: 'Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isCurrentlyRetired',
    label: 'Currently retired, discharged, or separated from service',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isNonActivatedMemberOfReserveNationalGuard',
    label: 'Only period of service was as a non-activated member of the Reserve or National Guard',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isSurvivingSpouse',
    label: 'Surviving spouse',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'entitlementCodeFromCoe',
    label: 'Entitlement code from COE',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'branchOfService',
    label: 'Branch Of Service',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'militaryStatus',
    label: 'Status',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'basicEntitlement',
    label: 'Basic Entitlement',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'bonusEntitlement',
    label: 'Bonus Entitlement',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'firstTimeVaUse',
    label: 'First Time VA Use',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isExemptVAFundingFee',
    label: 'Exempt from VA Funding Fee',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  // Homeownership Education and Housing Counseling
  {
    name: 'isBorrowerCompletedHomeownershipEducation',
    label:
      'Has the Borrower(s) completed homeownership education (group or web-based classes) within the last 12 months?',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'borrowerHomeownershipEducationFormat',
    label: 'What format was it in: (Check the most recent)',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'homeownershipEducationHousingCounselingAgencyIdNumber',
    label: 'Housing Counseling Agency ID Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'homeownershipEducationHousingCounselingAgencyName',
    label: 'Homeownership Education Housing Counseling Agency Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'homeownershipEducationHousingCounselingAgencyState',
    label: 'Homeownership Education Housing Counseling Agency State',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'homeownershipEducationHousingCounselingAgencyCity',
    label: 'Homeownership Education Housing Counseling Agency City',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'homeownershipEducationHousingCounselingAgencyAddress1',
    label: 'Homeownership Education Housing Counseling Agency Address 1',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'homeownershipEducationHousingCounselingAgencyAddress2',
    label: 'Homeownership Education Housing Counseling Agency Address 2',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'homeownershipEducationHousingCounselingAgencyZip',
    label: 'Homeownership Education Housing Counseling Agency Zip',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'homeownershipEducationNameOfTheHousingEducationProgram',
    label: 'Homeownership Education Name of the Housing Education Program',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'dateOfCompletionHomeownershipEducation',
    label: 'Date of completion homeownership education',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isBorrowerCompletedHousingCounseling',
    label:
      'Has the Borrower(s) completed housing counseling (customized counselor-to-client services) within the last 12 months?',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'borrowerHousingCounselingFormat',
    label: 'What format was it in: (Check the most recent)',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'housingCounselingAgencyIdNumber',
    label: 'Housing Counseling Agency ID Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'housingCounselingAgencyName',
    label: 'Housing Counseling Agency Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'housingCounselingAgencyState',
    label: 'Housing Counseling Agency State',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'housingCounselingAgencyCity',
    label: 'Housing Counseling Agency City',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'housingCounselingAgencyAddress1',
    label: 'Housing Counseling Agency Address 1',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'housingCounselingAgencyAddress2',
    label: 'Housing Counseling Agency Address 2',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'housingCounselingAgencyZip',
    label: 'Housing Counseling Agency Zip',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'housingCounselingNameOfTheHousingEducationProgram',
    label: 'Housing Counseling Name of the Housing Education Program',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'dateOfCompletionHousingCounseling',
    label: 'Date of completion housing counseling',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  // Language preference
  {
    name: 'languagePreference',
    label: 'Language preference',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'otherLanguagePreference',
    label: 'Other language preference',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  // Demographic
  {
    name: 'ethnicity',
    label: 'Ethnicity',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isEthnicityNotProvidedDuringFaceToFaceInterview',
    label: 'I do not wish to provide ethnicity information - Face to face interview',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'sex',
    label: 'Sex',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isSexInfoNotProvidedDuringFaceToFaceInterview',
    label: 'I do not wish to provide sex information - Face to face interview',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'race',
    label: 'Race',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isRaceNotProvidedDuringFaceToFaceInterview',
    label: 'I do not wish to provide race information - Face to face interview',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'demographicInformationProvisionType',
    label: 'The Demographic Information was provided through',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'ethnicityCollectedOnTheBasisOfVisualObservationOrSurname',
    label:
      'Was the ethnicity of the Borrower collected on the basis of visual observation or surname?',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'sexCollectedOnTheBasisOfVisualObservationOrSurname',
    label: 'Was the sex of the Borrower collected on the basis of visual observation or surname?',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'raceCollectedOnTheBasisOfVisualObservationOrSurname',
    label: 'Was the race of the Borrower collected on the basis of visual observation or surname?',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  // Home Possible
  {
    name: 'homeBuyerCounseling',
    label: 'HomeBuyer Counseling',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'counselingOtherDescription',
    label: 'Counseling Other Description',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'counselingFormat',
    label: 'Counseling Format',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'formatOtherDescription',
    label: 'Format Other Description',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const declarationsForm = {
  name: FormNames.DECLARATIONS,
  label: 'Declarations',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
